<div *ngIf="!link.IsEditableMode; else editMode" class="show-mode attr-height">
    <span class="url-width">URL</span>
    <span (click)="openLink()" class="long-label url-value-width" style="cursor: pointer;"
        title="{{link.AttributeValue}}">{{link.AttributeValue}}</span>
    <span class="url-label-width">URL Label</span>
    <span class="long-label url-value-width" title="{{link.Description}}">{{link.Description}}</span>
    <div class="action-buttons actions-width">
        <button (click)="editLink()">
            <mat-icon class="icon">create</mat-icon>
        </button>
        <button (click)="deleteLink()">
            <mat-icon class="icon">delete</mat-icon>
        </button>
    </div>
</div>

<ng-template #editMode>
    <div class="edit-mode attr-height">
        <span class="url-width">URL</span>
        <div class="edit-link-value url-value-width">
            <input type="text" [(ngModel)]="link.AttributeValue">
        </div>
        <span class="url-label-width">URL Label</span>
        <div class="edit-link-value url-value-width">
            <input type="text" [(ngModel)]="link.Description">
        </div>
        <div class="action-buttons actions-width">
            <button (click)="updateLink()" [disabled]="!isLinkValueChanged() || !isLinkValueValid()">
                <mat-icon class="icon">save</mat-icon>
            </button>
            <button (click)="cancelEditMode()">
                <mat-icon class="icon">clear</mat-icon>
            </button>
        </div>
    </div>
</ng-template>
